import { Component, OnInit, Input, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-date-input-dialog',
    templateUrl: './date-input-dialog.component.html',
    styleUrls: ['./date-input-dialog.component.scss'],
    standalone: false
})
export class DateInputDialogComponent implements OnInit {

  @Input() title: string = 'Ingrese fecha';
  @Input() message: string = 'Ingrese la fecha de inicio (formato YYYYMMDD):';
  @Input() btnOkText: string = 'Aceptar';
  @Input() btnCancelText: string = 'Cancelar';
  @Input() placeholder: string = 'YYYYMMDD';
  @Input() operationNumber: string = '';  // Número de operación del registro
  @Input() identifierNumber: string = ''; // Número de documento del registro

  dateValue: string = ''; // Formato YYYY-MM-DD para el input type="date"
  errorMessage: string = '';

  constructor(
    private dialogRef: MatDialogRef<DateInputDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    // Asignar los datos recibidos
    if (data) {
      this.title = data.title || 'Ingrese fecha';
      this.message = data.message || 'Ingrese la fecha de inicio (formato YYYYMMDD):';
      this.btnOkText = data.btnOkText || 'Aceptar';
      this.btnCancelText = data.btnCancelText || 'Cancelar';
      this.placeholder = data.placeholder || 'YYYYMMDD';
      this.operationNumber = data.operationNumber || '';
      this.identifierNumber = data.identifierNumber || '';
    }
  }

  ngOnInit() {
    // Inicialización si es necesaria
  }

  public decline() {
    this.dialogRef.close(null);
  }

  public accept() {
    // Validar que se haya ingresado una fecha
    if (!this.dateValue || this.dateValue.trim() === '') {
      this.errorMessage = 'La fecha no puede estar vacía.';
      return;
    }

    // Convertir de YYYY-MM-DD a YYYYMMDD
    const dateInYYYYMMDD = this.dateValue.replace(/-/g, '');
    
    // Validar formato YYYYMMDD resultante
    const dateRegex = /^\d{8}$/;
    if (!dateRegex.test(dateInYYYYMMDD)) {
      this.errorMessage = 'Formato de fecha inválido.';
      return;
    }

    this.dialogRef.close(dateInYYYYMMDD);
  }

  public dismiss() {
    this.dialogRef.close(null);
  }

  public onDateChange() {
    // Limpiar mensaje de error al cambiar la fecha
    this.errorMessage = '';
  }

}
